import BaseService from './baseService';
import {
    TaskGridFilter,
    TaskCopyModalSource,
    DatasetConvertTask,
    SaveMarketModel,
    TaskContract
} from 'store/taskMgmt/types';

export default class extends BaseService {
    constructor() {
        super('taskMgt');
    }

    /**
    * Gets task item.
    * @param {number} taskId - Task Id
    * @returns Task
    */
    getTask = (taskId: number) => this.httpGetRequest(taskId);

    /**
    * Gets task list.
    * @param {Object<TaskGridFilter>} filter - Task Grid Filter
    * @returns list of tasks.
    */
    getTasks = (filter: TaskGridFilter) => this.httpPostRequest('list', filter);

    /**
    * Edites task item.
    * @param {Object<TaskContract>} task - Task
    * @returns void
    */
    putTask = (task: TaskContract) => this.httpPutRequest('', task);

    /**
    * Deletes task item.
    * @param {number} taskId - Task Id
    * @returns void
    */
    deleteTask = (taskId: number) => this.httpDeleteRequest(taskId);

    /**
    * Archive task.
    * @param {number} taskId - Task Id
    * @returns void
    */
    archiveTask = (taskId: number) => this.httpPostRequest(`archive/${taskId}`);

    /**
    * Copies task.
    * @param {Object<TaskCopyModalSource>} task - Task for copy
    * @returns void
    */
    copyTask = (task: TaskCopyModalSource) => this.httpPostRequest("copy", task);

    /**
    * Gets leads lookup
    * @returns list of leads lookup
    */
    getLeadsLookup = () => this.httpGetRequest("leads");

    /**
    * Gets scenario for Task
    * @param {number} taskId - Task Id
    * @param {string} scenarioTypes - Scenario Types
    * @returns list of scenario lookups 
    */
    getScenariosLookup = (taskId: number, scenarioTypes?: string) => this.httpGetRequest(`${taskId}/scenarios${scenarioTypes ? `?scenarioTypes=${scenarioTypes}` : ''}`);

    /**
    * Gets scenario groups for Task
    * @param {number} taskId - Task Id
    * @returns list of scenario group lookups 
    */
    getScenarioGroupsLookup = (taskId: number) => this.httpGetRequest(`${taskId}/scenarioGroups`);

    /**
    * Updates DUPS release
    * @param {number} taskId - Task Id
    * @returns void
    */
    updateDUPSRelease = (taskId: number) => this.httpPostRequest(`${taskId}/release/update`);

    /**
    * Creates Market Model
    * @param {Object<SaveMarketModel>} request
    * @returns void
    */
    createMarketModel = (request: SaveMarketModel) => this.httpPostRequest("createMarketModel", request);

    /**
    * Restores Db
    * @param {number} taskId - Task Id
    * @returns void
    */
    restoreDb = (taskId: number) => this.httpPostRequest(`restore/${taskId}`);

    /**
    * Archives Db
    * @param {number} taskId - Task Id
    * @returns void
    */
    archiveDb = (taskId: number) => this.httpPostRequest(`archive/${taskId}`);

    /**
    * Initializes Db
    * @param {number} taskId - Task Id
    * @returns void
    */
    initDb = (taskId: number) => this.httpPostRequest(`init/${taskId}`);

    /**
    * Runs Task
    * @param {number} taskId - Task Id
    * @returns void
    */
    runTask = (taskId: number) => this.httpPostRequest(`run/${taskId}`);

    /**
    * Validates Task
    * @param {number} taskId - Task Id
    * @returns void
    */
    validateTask = (taskId: number) => this.httpPostRequest(`validate/${taskId}`);

    /**
    * Convertes to dataset task
    * @param {Object<DatasetConvertTask>} task - Task for convert
    * @returns void
    */
    datasetConvert = (task: DatasetConvertTask) => this.httpPostRequest("dataset-convert", task);

    /**
    * Deletes task item.
    * @param {number} taskId - Task Id
    * @returns void
    */
    forceDeleteTask = (taskId: number) => this.httpDeleteRequest(`forceDelete/${taskId}`);

    /**
    * Archive and Delete Db only
    * @param {number} taskId - Task Id
    * @returns void
    */
    archiveAndDeleteDb = (taskId: number) => this.httpDeleteRequest(`${taskId}/archive-delete-database`);

    /**
     * Update Major Release. Migrates a copy of the source task from one major release group to the next
     * @param {number} taskId  - Task Ids
     * @returns void
     */
    updateMajorRelease = (taskId: number) => this.httpPostRequest(`${taskId}/release/update-major`);
}